import { render, staticRenderFns } from "./References.vue?vue&type=template&id=1ee67b11&scoped=true"
import script from "./References.vue?vue&type=script&lang=js"
export * from "./References.vue?vue&type=script&lang=js"
import style0 from "./References.vue?vue&type=style&index=0&id=1ee67b11&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee67b11",
  null
  
)

export default component.exports